import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncDestinationUrgency = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "destination-urgency" */
        /* webpackPreload: true */
        './DestinationUrgency'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
